import { AutogenModelDrsCheck, AutogenRowDrsCheck } from "./autogen/AutogenModelDrsCheck";

export class ModelDrsCheck extends AutogenModelDrsCheck<RowDrsCheck> {
	constructor() {
		super(RowDrsCheck);
	}
}

export class RowDrsCheck extends AutogenRowDrsCheck {
}